export const initialState: DeviceRegistrationState = {
  errorMessage: '',
  isProcessing: false
};

export interface DeviceRegistrationState {
  errorMessage: string;
  isProcessing: boolean;
}



// WEBPACK FOOTER //
// ./src/pages/device-registration/state.ts